import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ExploreIcon = props => (
    <SvgIcon {...props} viewBox="0 0 18 18">
        <path d="M9.00001 1.94653L2.35001 16.4465L9.00001 12.6565L15.65 16.4465L9.00001 1.94653ZM9.00001 11.3865L4.79001 13.7865L9.00001 4.60653L13.21 13.7765L9.00001 11.3765V11.3865Z" />
    </SvgIcon>
);

export default ExploreIcon;
